const PopupNav = () => {

    // Wait for the DOM to be fully loaded
    document.addEventListener('DOMContentLoaded', function () {
        const navIcon = document.querySelector('.header__icon--nav');
        const popupNav = document.getElementById('popupNav');
        const closeNavBtn = document.getElementById('closeNav');

        // Function to open the popup nav
        function openNav() {
            popupNav.classList.add('active');
        }

        // Function to close the popup nav
        function closeNav() {
            popupNav.classList.remove('active');
        }

        // Event listener to open nav when icon is clicked
        navIcon.addEventListener('click', openNav);

        // Event listener to close nav when close button is clicked
        closeNavBtn.addEventListener('click', closeNav);

        // Close nav when pressing the Escape key
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && popupNav.classList.contains('active')) {
                closeNav();
            }
        });
    });
}

export default PopupNav;
